import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';
@Injectable()
export class DataService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService, public genericUtils: GenericUtils) { }

  getData(options, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${options.api}`,
      query: params
    };

    const functionToCall = this.returnFunctionToCall(options.id);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToCall.bind(this))
    );
  }

  returnFunctionToCall(widgetId) {
    if (widgetId === 29) {
      return this.processOTIFDeliveryData;
    }

    if (widgetId === 23) {
      return this.processTransportationData
    }

    if (widgetId === 11) {
      return this.processOTIFInwardData
    }

    if (widgetId === 15) {
      return this.processOTIFReturnData
    }
    if (widgetId === 7) {
      return this.processOTIFTransferData
    }
    if (widgetId === 19) {
      return this.processWarehouseData
    }

    if (widgetId === 22) {
      return this.processWarehouseUtlizationData
    }
  }
  //29
  processOTIFDeliveryData(data: any) {
    if (data && Object.keys(data.data).length
      && !data.data.data.non_breached_quantity
      && !data.data.data.in_process_quantity
      && !data.data.data.breached_quantity)
      return null;
    const underProcess = [],
      sla = [],
      qunatity = [],
      delivered_quantity = [],
      underProcess_quantity = []

    const processedData = this.drillOTIFDeliveryData(data.data);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const temp = {
      delivered_quantity: (Number(allData["breached_quantity"])) + (Number(allData["non_breached_quantity"])),
      underProcess_quantity: (Number(allData["in_process_quantity"])),
      sla: Number(
        (
          (100 * allData["non_breached_quantity"]) /
          (allData["breached_quantity"] +
            allData["non_breached_quantity"])
        ).toFixed(2)
      ),
      allKey: allKey
    };

    const chart1 = {
      dataSets: [
        temp.sla,
        temp.underProcess_quantity,
        temp.delivered_quantity],
      dataKeys: temp.allKey
    }
    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        const total =
          __v2Data[_dataName]["data"]["breached_quantity"] +
          __v2Data[_dataName]["data"]["non_breached_quantity"];

        underProcess.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["in_process_quantity"]) /
              total
            ).toFixed(2)
          )
        );
        sla.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["non_breached_quantity"]) /
              total
            ).toFixed(2)
          )
        );

        delivered_quantity.push(total);
        underProcess_quantity.push(__v2Data[_dataName]["data"]["in_process_quantity"])
      });
    }
    const chart2 = {
      dataSets: [
        sla,
        underProcess_quantity,
        delivered_quantity],
      dataKeys: dataKeys
    }
    return { chart1, chart2 };
  }

  drillOTIFDeliveryData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }

  //23
  processTransportationData(data: any) {
    // PLEASE UPDATE INCASE THE KEYS FOR DATA CHANGE!!
    const receivedData = data.data[0].TransportationSlaV2.data;
    if (!receivedData.breached_quantity && !receivedData.in_process_quantity && !receivedData.non_breached_quantity) return null;

    //
    const underProcess = [],
      sla = [],
      quantity = [];
    let dataKeys = [];
    let allKey = "All";
    let __v2Data = data.data[0].TransportationSlaV2;
    delete __v2Data["data"];
    if (Object.keys(__v2Data).length > 1) {
      dataKeys = Object.keys(__v2Data);
    } else if (Object.keys(__v2Data).length === 1) {
      allKey = Object.keys(__v2Data)[0];
      __v2Data = __v2Data[Object.keys(__v2Data)[0]];
      delete __v2Data["data"];

      if (Object.keys(__v2Data).length > 1) {
        dataKeys = Object.keys(__v2Data);
      } else if (Object.keys(__v2Data).length === 1) {
        allKey = Object.keys(__v2Data)[0];
        __v2Data = __v2Data[Object.keys(__v2Data)[0]];
        delete __v2Data["data"];
        dataKeys = Object.keys(__v2Data);
      }
    }
    const temp = { underProcess: 0, sla: 0, allKey: allKey };
    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        // this map is being used typically like a for loop
        const total =
          __v2Data[_dataName]["data"]["breached_quantity"] +
          __v2Data[_dataName]["data"]["non_breached_quantity"];

        const __underProcess = Number(
          (
            (100 * __v2Data[_dataName]["data"]["in_process_quantity"]) /
            total
          ).toFixed(2)
        );
        underProcess.push(__underProcess);
        temp["underProcess"] += __underProcess;

        const __sla = Number(
          (
            (100 * __v2Data[_dataName]["data"]["non_breached_quantity"]) /
            total
          ).toFixed(2)
        );
        sla.push(__sla);
        temp["sla"] += __sla;

        quantity.push(total + __v2Data[_dataName]["data"]["in_process_quantity"]);
      });
    }
    const chart1 = { dataSets: [temp.underProcess, temp.sla], dataKeys: temp.allKey }
    const chart2 = { dataSets: [underProcess, sla, quantity], dataKeys };
    return { chart1, chart2 };
  }

  //11
  processOTIFInwardData(data: any) {
    if (Object.keys(data.data).length === 0) return null;
    let sla = [],
      under_process = [];
    const volume = [];

    const processedData = this.drillOTIFInwardData(data.data);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const temp = {
      data: [Number((allData["under_process"]).toFixed(2)), Number((allData["sla"]).toFixed(2))],
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        sla.push(Number(__v2Data[_dataName]["data"]["sla"].toFixed(2)));
        volume.push(Number(__v2Data[_dataName]["data"]["volume"].toFixed(2)));
        under_process.push(
          Number(__v2Data[_dataName]["data"]["under_process"].toFixed(2))
        );
      });
    }
    under_process = under_process.map(datapoint => {
      return Number(datapoint.toFixed(2));
    });

    sla = sla.map(datapoint => {
      return Number(datapoint.toFixed(2));
    });
    const chart1 = { dataSets: temp.data, dataKeys: temp.allKey };
    const chart2 = { dataSets: [under_process, sla, volume], dataKeys };

    return { chart1, chart2 };
  }

  drillOTIFInwardData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }

  //15

  processOTIFReturnData(data: any) {
    if (Object.keys(data.data).length === 0) return null;
    const sla = [],
      volume = [],
      under_process = [];

    const processedData = this.drillOTIFReturnData(data.data);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const temp = {
      data: [Number((allData["under_process"]).toFixed(2)), Number((allData["sla"]).toFixed(2))],
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        sla.push(Number(__v2Data[_dataName]["data"]["sla"].toFixed(2)));
        volume.push(Number(__v2Data[_dataName]["data"]["volume"].toFixed(2)));
        under_process.push(
          Number(__v2Data[_dataName]["data"]["under_process"].toFixed(2))
        );
      });
    }
    const chart1 = { dataSets: temp.data, dataKeys: temp.allKey };
    const chart2 = { dataSets: [under_process, sla, volume], dataKeys }
    return { chart1, chart2 };
  }

  drillOTIFReturnData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }

  //7
  processOTIFTransferData(data: any) {
    if (Object.keys(data.data).length === 0) return null;
    const sla = [],
      volume = [],
      under_process = [];

    const processedData = this.drillOTIFTransferData(data.data);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const temp = {
      data: [Number((allData["under_process"]).toFixed(2)), Number((allData["sla"]).toFixed(2))],
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        sla.push(Number(__v2Data[_dataName]["data"]["sla"].toFixed(2)));
        volume.push(Number(__v2Data[_dataName]["data"]["volume"].toFixed(2)));
        under_process.push(
          Number(__v2Data[_dataName]["data"]["under_process"].toFixed(2))
        );
      });
    }
    const chart1 = { dataSets: temp.data, dataKeys: temp.allKey }
    const chart2 = { dataKeys, dataSets: [under_process, sla, volume] };
    return { chart1, chart2 };
  }

  drillOTIFTransferData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }

  //19
  processWarehouseData(data: any) {
    //PLEASE MODIFY THIS CONDITION IF DATA KEY CHANGES!!
    const receivedData = data.data[0].WarehouseSlaV2.data
    if (!receivedData.breached_quantity && !receivedData.in_process_quantity && !receivedData.non_breached_quantity) return null;
    //

    const underProcess = [],
      sla = [],
      quantity = [];

    const processedData = this.drillWarehouseData(data.data[0].WarehouseSlaV2);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const temp = {
      // underProcess: Number(
      //   (
      //     (100 * allData["in_process_quantity"]) /
      //     (allData["breached_quantity"] +
      //       allData["in_process_quantity"] +
      //       allData["non_breached_quantity"])
      //   ).toFixed(2)
      // ),
      sla: Number(
        (
          (100 * allData["non_breached_quantity"]) /
          (allData["breached_quantity"] +
            allData["non_breached_quantity"])
        ).toFixed(2)
      ),
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        const total =
          __v2Data[_dataName]["data"]["breached_quantity"] +
          __v2Data[_dataName]["data"]["non_breached_quantity"];

        underProcess.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["in_process_quantity"]) /
              total
            ).toFixed(2)
          )
        );

        sla.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["non_breached_quantity"]) /
              total
            ).toFixed(2)
          )
        );

        quantity.push(total + __v2Data[_dataName]["data"]["in_process_quantity"]);
      });
    }
    const chart1 = { dataSets: [temp.sla], dataKeys: temp.allKey };
    const chart2 = { dataSets: [sla, quantity], dataKeys }; // underProcess - we aren't sending this 
    return { chart1, chart2 };
  }

  drillWarehouseData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }

  //22 

  processWarehouseUtlizationData(data: any) {
    if (Object.keys(data.data[0].WarehouseUtilizationV2).length === 0) return null;
    const utilized = [],
      capacity = [];

    const processedData = this.drillWarehouseUtlizationData(
      data.data[0].WarehouseUtilizationV2
    );

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];
    const temp = { utilized: allData["total_utilization_percent"], allKey, total: allData['total_volume'] };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {


        utilized.push(
          Number(
            __v2Data[_dataName]["data"]["total_utilization_percent"].toFixed(2)
          )
        );
        capacity.push(
          Number(
            (__v2Data[_dataName]["data"]["total_volume"] / 1000).toFixed(0)
          )
        );
      });
    }
    const chart1 = { dataSets: [], dataKeys: temp.allKey, total: temp.total }
    const available = [];
    utilized.forEach((element, index) => {
      available.push(
        // Number(((element * 100) / chartData.chart2.capacity[index]).toFixed(2))
        Number(Math.max(0, 100 - element).toFixed(2))
      );
    });
    const chart2 = { dataSets: [available, utilized, capacity], dataKeys };
    return { chart1, chart2 };
  }

  drillWarehouseUtlizationData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }


  createChart(chartData, options) {
    let chart1;
    if (!options[0].yAxis[1]) {
      chart1 = this.genericUtils.deepCopyFunction(HSET.chartExtra);
    }
    else {
      chart1 = this.genericUtils.deepCopyFunction(HSET.chart1);
    }

    const chart2 = this.genericUtils.deepCopyFunction(HSET.chart2);
    // data setting in series
    //chart 1
    for (let i = 0; i < chart1.series.length - 1; i++) {
      if (chartData.chart1.dataSets[i]) {
        chart1.series[i].data = [chartData.chart1.dataSets[i]];
      } else {
        chart1.series.splice(i, 1);
      }
    }
    chart1.xAxis.categories = chartData.chart1.dataKeys;
    //chart 2
    for (let i = 0; i < chart2.series.length - 1; i++) {
      if (chartData.chart2.dataSets[i]) {
        chart2.series[i].data = chartData.chart2.dataSets[i];
      } else {
        chart2.series.splice(i, 1);
      }
    }
    chart2.xAxis.categories = chartData.chart2.dataKeys;

    // data setting in series ends

    if (chartData.chart2.total) {
      chart1.tooltip.pointFormat = "Utilized:" + chartData.chart2.utilized.toFixed(2) + '%' + '<br/>' + 'Total:' + chartData.chart2.total.toFixed(2)
    }

    // chart1.tooltip.positioner = function () {
    //   return { x: 10, y: 60 };
    // };

    if (options[0].xAxis) {
      //do nothing... a provision for later
    }

    if (options[0].yAxis) {
      //In case the y Axis has only one axis, not two
      // if (!options[0].yAxis[1]) {
      //   chart1.yAxis.pop();
      // }
      for (let i = 0; i < options[0].yAxis.length; i++) {
        // A provision for future, if needed - this chart doesn't have min - max
        if (options[0].yAxis[i].min) {
          chart1.yAxis[i].min = options[0].yAxis[i].min;
        }
        if (options[0].yAxis[i].max) {
          chart1.yAxis[i].max = options[0].yAxis[i].max;
        }

        if (options[0].yAxis[i].title) {
          const TITLE = options[0].yAxis[i].title;
          if (TITLE.text) {
            chart1.yAxis[i].title.text = TITLE.text;
          }
          if (TITLE.style) {
            chart1.yAxis[i].title.style.fontSize = TITLE.style.fontSize;
            chart1.yAxis[i].title.style.fontWeight = TITLE.style.fontWeight;
            chart1.yAxis[i].title.style.color = TITLE.style.fontColor;
            // do nothing for now. This is just a provision for the future
          }
        }

        if (options[0].yAxis.label) {
          const LABEL = options[0].yAxis[i].title;
          if (LABEL.text) {
            chart1.yAxis[i].labels.text = LABEL.text;
          }
          if (LABEL.style) {
            chart1.yAxis[i].labels.style.fontSize = LABEL.style.fontSize;
            chart1.yAxis[i].labels.style.fontWeight = LABEL.style.fontWeight;
            chart1.yAxis[i].labels.style.color = LABEL.style.fontColor;
          }
        }
      }
    }

    if (options[0].legend) {
      // NO legend here
      // if (options[0].legend.style) {
      //   const STYLE = options[0].legend.style;
      //   chart1.legend.itemStyle.fontSize = STYLE.fontSize;
      //   chart1.legend.itemStyle.fontWeight = STYLE.fontWeight;
      //   chart1.legend.itemStyle.color = STYLE.color;
      // }

      if (options[0].legend.colorSet) {
        const COLORSET = options[0].legend.colorSet;
        for (let i = 0; i < COLORSET.length; i++) {
          if (chart1.series[i]) {
            chart1.series[i].color = COLORSET[i];
          }

        }
      }
    }

    if (options[0].series) {
      if (options[0].series.name) {
        const NAMES = options[0].series.name;
        const TOOLTIP = options[0].series.tooltipSuffix ? options[0].series.tooltipSuffix : [];
        for (let i = 0; i < NAMES.length; i++) {
          if (chart1.series[i]) {
            chart1.series[i].name = NAMES[i];
            if (TOOLTIP[i]) {
              chart1.series[i].tooltip.valueSuffix = TOOLTIP[i];
            }
          }

        }
      }
    }

    if (options[0].tooltip) {
      chart1.tooltip = options[0].tooltip;
    }

    // if (options[0].noTarget) {
    //   chart1.series.pop();
    //   chart1.plotOptions.line.dataLabels.enabled = false;
    // }

    //FOR CHART2
    if (options[1].xAxis) {
      //do nothing... a provision for later
    }

    if (options[1].yAxis) {
      for (let i = 0; i < options[1].yAxis.length; i++) {
        // A provision for future, if needed - this chart doesn't have min - max
        if (options[1].yAxis[i].min) {
          chart2.yAxis[i].min = options[1].yAxis[i].min;
        }
        if (options[1].yAxis[i].max) {
          chart2.yAxis[i].max = options[1].yAxis[i].max;
        }
        if (options[1].yAxis[i].title) {
          const TITLE = options[1].yAxis[i].title;
          if (TITLE.text) {
            chart2.yAxis[i].title.text = TITLE.text;
          }
          if (TITLE.style) {
            chart2.yAxis[i].title.style.fontSize = TITLE.style.fontSize;
            chart2.yAxis[i].title.style.fontWeight = TITLE.style.fontWeight;
            chart2.yAxis[i].title.style.color = TITLE.style.fontColor;
            // do nothing for now. This is just a provision for the future
          }
        }

        if (options[1].yAxis.label) {
          const LABEL = options[1].yAxis[i].title;
          if (LABEL.text) {
            chart2.yAxis[i].labels.text = LABEL.text;
          }
          if (LABEL.style) {
            chart2.yAxis[i].labels.style.fontSize = LABEL.style.fontSize;
            chart2.yAxis[i].labels.style.fontWeight = LABEL.style.fontWeight;
            chart2.yAxis[i].labels.style.color = LABEL.style.fontColor;
          }
        }
      }
    }

    if (options[1].legend) {
      if (options[1].legend.style) {
        const STYLE = options[1].legend.style;
        chart2.legend.itemStyle.fontSize = STYLE.fontSize;
        chart2.legend.itemStyle.fontWeight = STYLE.fontWeight;
        chart2.legend.itemStyle.color = STYLE.color;
      }

      if (options[1].legend.colorSet) {
        const COLORSET = options[1].legend.colorSet;
        for (let i = 0; i < COLORSET.length; i++) {
          if (chart2.series[i]) {
            chart2.series[i].color = COLORSET[i];
          }

        }
      }
    }

    if (options[1].series) {
      if (options[1].series.name) {
        const NAMES = options[1].series.name;
        const TOOLTIP = options[1].series.tooltipSuffix ? options[1].series.tooltipSuffix : [];
        for (let i = 0; i < NAMES.length; i++) {
          if (chart2.series[i]) {
            chart2.series[i].name = NAMES[i];
            if (TOOLTIP[i]) {
              chart2.series[i].tooltip.valueSuffix = TOOLTIP[i];
            }
          }

        }
      }
    }

    if (options[1].tooltip) {
      chart2.tooltip = options[1].tooltip;
    }

    if (options[1].noTarget) {
      chart2.series.pop();
      chart2.plotOptions.line.dataLabels.enabled = false;
    }


    return { chart1, chart2 };
  }


}
